// extracted by mini-css-extract-plugin
module.exports = {"aspect-ratio-square-image-box":"AspectRatioSquareContainer_aspect-ratio-square-image-box__yy4gZ","image-item":"AspectRatioSquareContainer_image-item__Ida4x"};